// extracted by mini-css-extract-plugin
export default {"v-standardBorderRadius":"4px","v-fog":"var(--fog)","info":"submit_form__info__L3wLA"};